import { transformCurrencyAmountDto } from './currency-amount';
export const transformCollectionsPlanPricing = dto => ({
  id: dto.id,
  effectiveDays: dto.effective_days,
  maxActiveCount: dto.max_active_count,
  default: dto.default,
  totalPrice: transformCurrencyAmountDto(dto.total_price)
});
export const transformCollectionsPlansPricing = dtos => dtos.map(transformCollectionsPlanPricing);